import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="consentimientos-firmas-representantes"
export default class extends Controller {
  static targets = ['checkbox', 'sectionPaciente', 'sectionRepresentantes']

  connect() {
    if(this.checkboxTarget.checked) {
      this.sectionRepresentantesTarget.classList.remove('d-none')
    } else {
      this.sectionPacienteTarget.classList.remove('d-none')
    }
  }

  toggleSection(e) {
    e.preventDefault()

    if (this.checkboxTarget.checked) {
      this.sectionRepresentantesTarget.classList.remove('d-none')
      this.sectionPacienteTarget.classList.add('d-none')
    } else {
      this.sectionPacienteTarget.classList.remove('d-none')
      this.sectionRepresentantesTarget.classList.add('d-none')
    }
  }
}
